var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600",
        scrollable: "",
        persistent: "",
        eager: ""
      },
      on: {
        keydown: function keydown($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.close($event)
        },
        "click:outside": _vm.close
      },
      model: {
        value: _vm.dialogProxy,
        callback: function callback($$v) {
          _vm.dialogProxy = $$v
        },
        expression: "dialogProxy"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "app-card card-borderless"
        },
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Manage Users ")]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "pt-2 pb-3"
            },
            [
              _c(
                "v-row",
                [
                  _vm.loadingUsers
                    ? _c(
                        "v-col",
                        {
                          staticClass: "text-center",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: "64",
                              color: "primary"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.users.length
                    ? [
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _vm._v(
                              ' Managing users for "' +
                                _vm._s(_vm.path) +
                                '". To change a user’s password, add that user with the new password. '
                            )
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c("gg-input-label", [
                              _vm._v("Select a User to delete:")
                            ]),
                            _c(
                              "v-radio-group",
                              {
                                attrs: {
                                  column: ""
                                },
                                model: {
                                  value: _vm.user,
                                  callback: function callback($$v) {
                                    _vm.user = $$v
                                  },
                                  expression: "user"
                                }
                              },
                              _vm._l(_vm.users, function(usr) {
                                return _c("v-radio", {
                                  key: usr,
                                  attrs: {
                                    color: "primary",
                                    value: usr,
                                    label: usr
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _vm._v(
                            ' No users found. You can add users through "Add User" menu. '
                          )
                        ]
                      )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end pb-4 pt-0"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.users.length,
                      expression: "users.length"
                    }
                  ],
                  attrs: {
                    disabled: !_vm.user,
                    loading: _vm.loadingDelete
                  },
                  on: {
                    click: _vm.deleteUser
                  }
                },
                [_vm._v(" Delete User ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }